<template>
  <b-form-group
    label="Sayfa Meta İçerik"
    label-for="metatag_description"
  >
    <validation-provider
      #default="{ errors }"
      name="Sayfa Meta İçerik"
      rules="required"
    >
      <b-form-input
        id="metatag_description"
        v-model="dataItem.metatag_description"
        placeholder="Sayfa Meta Başlığı"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'MetaTagDescription',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['serviceCategories/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
